import { ContentState } from '../reducers/content.reducer';
import { LocalizedContent } from 'src/app/commons/model/localized-content';

export const currentContent = (state: ContentState): any => LocalizedContent.deserialize(state.currentContent);
export const currentSection = (state: ContentState): string => state.currentSection;
export const currentSectionName = (state: ContentState): string => state.currentSectioName;
export const currentGUID = (state: ContentState): string => state.currentGUID;
export const currentSectionID = (state: ContentState): number => state.currentSectionID;
export const currentSectionGUID = (state: ContentState): string => state.currentSectionGUID;